import { Validator } from '@leverege/validator';
import { Constants } from '@leverege/molten-core';
import resourceImageValidator from "./types/resourceImageValidator.js";
import BuiltInValidatorProcessor from "./types/BuiltInValidatorProcessor.js";
const emailValidator = Validator.optional(Validator.isEmail);
const phoneValidator = Validator.optional(Validator.isPhone);
const install = molten => {
  molten.addPlugin(Constants.BLUEPRINTS_PROCESSOR, BuiltInValidatorProcessor);
  molten.addPlugin('BlueprintAttributeFormValidator', {
    type: 'email',
    validator: attr => ({
      active: true,
      submitValidator: (value, ...rest) => {
        if (Array.isArray(value)) {
          return value.every(v => emailValidator(v, ...rest));
        }
        return emailValidator(value, ...rest);
      },
      validator: (value, ...rest) => {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            const nValue = value.at(-1);
            return emailValidator(nValue, ...rest);
          }
        }
        return emailValidator(value, ...rest);
      },
      allow: (value, ...rest) => {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            const nValue = value.at(-1);
            return emailValidator(nValue, ...rest);
          }
        }
        return true;
      }
    })
  });
  molten.addPlugin('BlueprintAttributeFormValidator', {
    type: 'phone',
    validator: attr => ({
      active: true,
      submitValidator: (value, ...rest) => {
        if (Array.isArray(value)) {
          return value.every(v => phoneValidator(v, ...rest));
        }
        return phoneValidator(value, ...rest);
      },
      validator: (value, ...rest) => {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            const nValue = value.at(-1);
            return phoneValidator(nValue, ...rest);
          }
        }
        return phoneValidator(value, ...rest);
      },
      allow: (value, ...rest) => {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            const nValue = value.at(-1);
            return phoneValidator(nValue, ...rest);
          }
        }
        return true;
      }
    })
  });
  molten.addPlugin('BlueprintAttributeFormValidator', {
    type: 'required',
    validator: attr => ({
      active: true,
      submitValidator: Validator.required
    })
  });
  molten.addPlugin('BlueprintAttributeFormValidator', {
    type: 'image',
    validator: resourceImageValidator
  });
};
export default {
  install
};